import {
  IDataType,
} from "./datatypes";

export function mapDatatype(backendDatatype: any): IDataType { // eslint-disable-line 
  if (!backendDatatype) {
    return { type: "text" };
  }

  const type = typeof backendDatatype === "string" ? backendDatatype : backendDatatype.type;

  switch (type) {
    case "text":
      return { type: "text" };
    case "number":
      return { type: "number" };
    case "dateTime":
      return { type: "dateTime" };
    case "date":
    case "datetime":
      return { type: "dateTime" };
    case "textarea":
      return { type: "textarea", size: backendDatatype.size || "small" };
    case "noDisplayCol":
      return { type: "noDisplayCol" };
    case "action":
      return {
        type: "action",
        buttonText: backendDatatype.buttonText || "Action",
        buttonColor: backendDatatype.buttonColor || "primary",
        borderColor: backendDatatype.borderColor || "primary",
        disable: backendDatatype.disable,
        show: backendDatatype.show,
        showCondition: backendDatatype.showCondition,
        displayName: backendDatatype.displayName,
        disabled: backendDatatype.disabled,
      };
    default:
      return { type: "text" };
  }
}
